import React from "react";
import AdminResizableSplit from "./AdminResizableSplit";

/**
 * Ledger index + detail inspector (amf-grid pattern).
 */
export default function AdminFloorGrid({ sectionKey, index, detail }) {
  return (
    <AdminResizableSplit
      storageKey={`bb-admin-floor-index:${sectionKey}`}
      defaultSize={320}
      minSize={240}
      maxSize={640}
      className="amf-grid"
      leadClassName="amf-grid-index"
      trailClassName="amf-grid-detail"
      stackedClassName="amf-grid amf-grid-stacked"
      lead={index}
      trail={detail}
    />
  );
}
